<template>
    <div>
        <webix-ui :config="webixUI"/>
    </div>
</template>

<script>
    import { webixUI, init, cleanup } from './_trialCompleteUser';

    export default {
        name: 'TrialCompleteUser',
        data() {
            return {
            }
        },
        created() {
            this.webixUI = webixUI;
        },
        mounted: function() {
            let component = this;
            this.$nextTick(function() {
                init();
            })
        }, 
        beforeUnmount: function() {
            cleanup();
        }
    }
</script>


<style scoped>
</style>